import { render, staticRenderFns } from "./route-svg-icons-modal.vue?vue&type=template&id=13dd5e4c&"
import script from "./route-svg-icons-modal.vue?vue&type=script&lang=ts&"
export * from "./route-svg-icons-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports